var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.title,
      "isDialogActive": _vm.isDialogActive,
      "loading": _vm.loadingAck || _vm.loadingRecurringEvent,
      "rightLoading": _vm.loadingAck || _vm.loadingRecurringEvent || _vm.loadingUpdateEventSeries,
      "rightDisabled": _vm.loadingRecurringEvent,
      "rightText": _vm.rightText
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "leftClick": function leftClick($event) {
        _vm.isDialogActive = false;
      },
      "rightClick": _vm.onRightClick,
      "close": function close($event) {
        _vm.isDialogActive = false;
      }
    }
  }, [_c('v-stepper', {
    attrs: {
      "elevation": 0
    },
    model: {
      value: _vm.step,
      callback: function callback($$v) {
        _vm.step = $$v;
      },
      expression: "step"
    }
  }, [_c('v-stepper-items', [_c('v-stepper-content', {
    attrs: {
      "step": "0"
    }
  }, [_c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "elevation": 0
          }
        }, 'v-btn', attrs, false), on), [_vm._v(" " + _vm._s(_vm.readableAckDate) + " ")])];
      }
    }])
  }, [_c('v-date-picker', {
    model: {
      value: _vm.ackDate,
      callback: function callback($$v) {
        _vm.ackDate = $$v;
      },
      expression: "ackDate"
    }
  })], 1), _c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on,
            attrs = _ref2.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-2",
          attrs: {
            "elevation": 0
          }
        }, 'v-btn', attrs, false), on), [_vm._v(" " + _vm._s(_vm.readableAckTime) + " ")])];
      }
    }])
  }, [_c('v-time-picker', {
    model: {
      value: _vm.ackTime,
      callback: function callback($$v) {
        _vm.ackTime = $$v;
      },
      expression: "ackTime"
    }
  })], 1)], 1), _c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('components.EventCardAcknowledgementDialog.description.belongsTo', {
        series: _vm.rruleTextTranslated,
        ogStart: _vm.originalStartOfRecurring,
        next: _vm.nextPlannedOccurence
      }))
    }
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('components.EventCardAcknowledgementDialog.description.moveSeries'))
    }
  }), _c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref3) {
        var on = _ref3.on,
            attrs = _ref3.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "elevation": 0
          }
        }, 'v-btn', attrs, false), on), [_vm._v(" " + _vm._s(_vm.readableNextOccurenceDate) + " ")])];
      }
    }])
  }, [_c('v-date-picker', {
    model: {
      value: _vm.nextOccurenceDate,
      callback: function callback($$v) {
        _vm.nextOccurenceDate = $$v;
      },
      expression: "nextOccurenceDate"
    }
  })], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }